import {InputFileAcceptMimes, InputFileAcceptTypes, UploadStates} from "../../../../../core/constants/enums";
import React, {useState} from "react";
import {Col, Row} from "reactstrap";
import {ReactComponent as ImagePlaceholder} from "../../../../../assets/images/dropzone/image-placeholder.svg";
import DropZone from "../../../base/dropzone";
import classnames from "classnames";
import Utils from "../../../../../core/services/utils/utils";

const AddProductImageDropZone = ({
                                     disabled,
                                     accept = [
                                         InputFileAcceptMimes.images,
                                         InputFileAcceptTypes.heic,
                                         InputFileAcceptTypes.heif,
                                     ],
                                     onSuccess,
                                     uploading,
                                     uploadState,
                                     tempUrl,
                                     setTempUrl,
                                     url,
                                     id,
                                 }) => {
    const [loading, setLoading] = useState(false);
    const hasError = uploadState === UploadStates.error;


    return (
        <>
            <DropZone
                disabled={disabled}
                identifier={'product-image'}
                accept={accept}
                error={hasError}
                onSuccess={onSuccess}
                multiple={false}
                setTempUrl={setTempUrl}
                loading={loading}
                uploading={uploading}
                setLoading={setLoading}
                openOnClick={!url?.length}
                className={`row no-gutters align-items-center justify-content-center `}
                noParse>
                {() => uploading
                    ? <div
                        className={'d-flex flex-column align-items-center justify-content-center cursor-progress-hover'}>
                        <span className={classnames(
                            `text-md font-weight-bold position-absolute z-index-1`,
                            {"red": uploadState.state === UploadStates.error},
                        )}>
                            {
                                uploadState.state === UploadStates.pending
                                    ? ((uploadState.percentage ?? 0) + '%')
                                    : uploadState.state
                            }
                        </span>
                        <img
                            id={id}
                            className='cursor-progress-hover'
                            src={tempUrl}
                            alt={`dropzone-${id}`}
                            style={{
                                opacity: uploadState.state === UploadStates.done ? '1' : '0.5'
                            }}
                        />
                    </div>
                    : url?.length > 0
                        ? <img
                            className='cursor-pointer-hover'
                            src={Utils.encodeFileUrl(url)}
                            alt={`dropzone-${id}`}
                        />
                        : (
                            <Row
                                className={`w-100 no-gutters align-items-center justify-content-center ${uploading ? 'cursor-progress-hover' : ''} ${disabled || loading ? 'cursor-not-allowed-hover' : 'cursor-pointer-hover'}`}>
                                <Col xs={12} className={'d-flex justify-content-center align-items-center'}>
                                    <ImagePlaceholder/>
                                </Col>
                                <Col xs={12} className={'d-flex justify-content-center align-items-center'}>
                                    <p className={'placeholder-text'}>
                                        Drag Your File or Click Here to Upload Your Image
                                    </p>
                                </Col>
                            </Row>
                        )
                }
            </DropZone>
        </>


    );
}

export default AddProductImageDropZone;
